<template>
<div>
<spinner v-bind:spinner='spinner'></spinner>

<printZebraModal :key="refresh1" v-bind:data='data'></printZebraModal>  
<print-epl-modal :key="refresh2"  v-bind:data='data'></print-epl-modal>

<!--
<div class="card border-success">
  <div class="card-header bg-success text-white">
  <h4>
  <i  class="fas fa-print mr-2" aria-hidden="true"></i>  
  STAMPA ETICHETTE VARIANTI</h4></div>
  <div class="card-body text-dark">  

 -->   

  <div class="row mt-3">

<div class="col">

  <div class="table-wrapper-scroll-y my-custom-scrollbar">              
  <table class="table table-hover table-bordered table-sm mb-0" id="table">
    <thead >
      <tr class="table-primary">
        <th>
         # 
        </th>  
        <th>
         
        </th>  
        <th>
         STORE  
        </th>    
        <th>
        BARCODE
        </th>
        <th>
        COLORE
        </th>
        <th>
        COLORE FORNITORE
        </th>  
        <th>
        MISURA
        </th>
        <th class="text-right" >
        Q.TA'
        </th>
        
      
        <th v-if="isAdmin!=0" class="text-right">
        {{prAcquisto}}
        
        </th>
        <th class="text-right">
        {{prVendita}}
        </th>    
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in filteredItems" :key="index">
        <td>
          {{index+1}}
        </td>
        <td>
          <input type="checkbox" v-model="item.selected">
        </td>
        <td>
            {{item.store}}
        </td>
          
        <td>
         {{item.barcode}}
        </td>
        <td>
         {{item.color}}  
        </td>
         <td>
         {{item.supplierColor}} 
        </td>
        <td>
         {{item.size}}
        </td>
        <td class="text-right">
         <!--<strong>{{item.qty}}</strong>-->
         <input  :id="'id_'+index" v-model.number="item.qty"  class="form-control-sm inputClass" type="number" >
        </td>
        
        <td v-if="isAdmin != 0 " class="text-right">
         {{Number(item.costPrice).toLocaleString('de-DE',{ style: 'currency', currency: 'EUR' }) }}
        </td>
        <td class="text-right">
         {{Number(item.retailPrice).toLocaleString('de-DE',{ style: 'currency', currency: 'EUR' })}}
        </td>
      </tr>
    </tbody>
  </table> 
 </div>

  <label class="mt-4" for="cerca">
    <i style="color:navy" class="fas fa-filter mr-2" aria-hidden="true"></i>
    <strong>Filtra</strong></label>
  <input class="form-control" type="text" name="query" v-model="filterKey">
  <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
</div>


</div>




<button @click="selectAll(1)"  class="btn btn-secondary float-left mr-2 mt-2 rounded-sm">SELEZIONA TUTTI
   <i style="color:yellow" class="fas fa-check ml-3" aria-hidden="true"></i>
</button>


<button @click="selectAll(0)"  class="btn btn-secondary float-left mr-3 mt-2 rounded-sm ">DESELEZIONA TUTTI
   <i style="color:yellow" class="far fa-circle ml-3" aria-hidden="true"></i>
</button>




<button v-if="company.printer_type=='ZPL'"  @click="printModal('ZPL')" class="btn btn-primary mt-2 rounded-sm">STAMPA ETICHETTE 
  <i  class="fas fa-print ml-2" aria-hidden="true"></i>
</button>

<button  v-if="company.printer_type=='EPL'"  @click="printModal('EPL')"  class="btn btn-info  mt-2 ml-2 rounded-sm">STAMPA ETICHETTE
  <i  class="fas fa-print ml-2" aria-hidden="true"></i>
  
</button>


</div>





  


<!--
</div>
</div> 
-->

</template>

<script>
import api                from '@/api';
import { mapGetters }     from 'vuex';

import spinner            from '@/components/common/Spinner.vue';


import alertBox           from '@/components/common/AlertBox.vue';
import printZebraModal    from '@/components/common/PrintZebraModal.vue';
import printEplModal      from '@/components/common/PrintJSPMModal.vue';

export default {
  props : ['item'],
   components: {
     spinner,alertBox,printZebraModal,printEplModal
   
  },
  
  data () {
    return {

    refresh1       : 0,
    refresh2       : 100,
    
    

    msg            :{
      title        : ''
    }, 
    prAcquisto     : 'prezzo di ACQUISTO',
    prVendita      : 'prezzo di VENDITA',

    items          : [],
    spinner        : false,
    filterKey      : '',
    data           : []

    }
  },
  computed: 
  {  
    ...mapGetters(['company','isAdmin']),

    filteredItems : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },
     

  },
  watch: 
  {
    
  },
      
  mounted()
  {
   
    this.getData()

  },
  created()  
  {

    
  }, 
  methods: 
    {
      
     printModal(lang)
      {
        
        this.data = []
        this.items.forEach(item=>{
          if(item.selected==1 && item.qty > 0)
          {
            this.data.push(item)
          }
        })

        if(lang=='ZPL')
        {
          this.refresh1++
          this.$nextTick(() => {
           $('#printZebraModal').modal({keyboard: false,backdrop:'static','show':true});
            
        })
        }
        else
        {
          this.refresh2++
          this.$nextTick(() => {
           $('#printEPLModal').modal({keyboard: false,backdrop:'static','show':true});
            
        })
        }
       
        
      },
       
      selectAll(value)
      {

        this.filteredItems.forEach(item =>{
          item.selected = value
        })
      },
    
    
      
      async getData() 
      {


        this.spinner = true          
        let data     = {'productId' : this.item.productId}
        let sp       = {'sp' : 'spProductBarcodeStockWareHouse'}        
        
        if(this.item.cart)
        {
          data     = {'productId' : this.item.productId,'storeId':this.item.storeId}
          sp       = {'sp' : 'spProductStoreBarcodesStockWareHouse'}        
          
        }

        if(this.item.movementId)
        {
          data     = {'productId' : this.item.productId,'movementId':this.item.movementId}
          sp       = {'sp':'spStockMovementProductBarcodes'}        
        
        }
                
        const json     = Object.assign(data, sp)
        await api.post(json).then(res => {
                   
          if(res.status==200)
            {
              
              this.items = res.data.recordsets[0]      
             

            }
           else if(res.status==500)
           {
                

              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type = 1                
                
                    
           } 
           else
            { 
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1                 
            } 
          

          }).catch(err => {
              
              
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.nessage
              this.msg.type = 1                 

              
          }).finally(() => {
          this.spinner = false
        });
        


        
    
        

      }
    },
    
}
</script>

<style scoped>
h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
p{
  font-family: 'Roboto Condensed';
  font-size: 25px;
}
.my-custom-scrollbar {
position : relative;
height   : 400px;
overflow : auto;
}
.table-wrapper-scroll-y {
display  : block;
}
a{
  font-family : 'Roboto Condensed';
  font-size   : 25px;
  color       : red
}

input[type='checkbox'] {
 
  cursor         : pointer;
 
}
.table th:first-child
{
  border-radius : 0 0 0 8px;
}
.table th:last-child
{
  border-radius : 0 8px 0 0;  
}
.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;

    color       : rgb(16, 16, 15) !important;
    background  : #a9cbe2;
    
    
    position     : sticky;
    top          : 0;
    z-index      : 10;
    height       : 40px;

 }
</style>